import { render, staticRenderFns } from "./compare-detail.vue?vue&type=template&id=0ac7581a&scoped=true&"
import script from "./compare-detail.vue?vue&type=script&lang=ts&"
export * from "./compare-detail.vue?vue&type=script&lang=ts&"
import style0 from "./compare-detail.vue?vue&type=style&index=0&id=0ac7581a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac7581a",
  null
  
)

export default component.exports